import { registerEnumType } from 'type-graphql'

export enum ArAgingBucketEnum {
  current = 'current',
  d1to30 = 'd1to30',
  d31to60 = 'd31to60',
  d61to90 = 'd61to90',
  d90plus = 'd90plus',
}

registerEnumType(ArAgingBucketEnum, {
  name: 'ArAgingBucketEnum',
  description: 'Accounts-receivable aging buckets by days past due.',
})
